// Contrato das rotas Node que substituem as chamadas Cake ainda usadas.
// O teste unitário valida método, caminho e parâmetros a partir daqui.
// A definição para a API está em docs/cake-migration/technical.md.

function request(method, url, extra) {
  return {
    method,
    url,
    params: extra && extra.params,
    data: extra && extra.data,
  }
}

export const cakeLegacyRoutes = {
  legacyListProducts: {
    cake: 'GET /products/json/list/?layout=ajax',
    responseKeys: ['list', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/products')
    },
  },
  legacyProductFieldsMap: {
    cake: 'GET /products/json/map/',
    responseKeys: ['map', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/products/map')
    },
  },
  legacyListClients: {
    cake: 'GET /clients/json/list/?layout=ajax',
    responseKeys: ['list', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/clients')
    },
  },
  legacyGetClient: {
    cake: 'GET /clients/json/view/{id}/?layout=ajax',
    responseKeys: ['view'],
    build(input) {
      return request('get', `/legacy/cake/clients/${input.id}`)
    },
  },
  legacyCountClients: {
    cake: 'GET /clients/json/count/total/?layout=ajax',
    responseKeys: ['count', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/clients/count')
    },
  },
  legacyClientFieldsMap: {
    cake: 'GET /clients/json/map',
    responseKeys: ['map', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/clients/map')
    },
  },
  legacySaveClient: {
    cake: 'POST /clients/save/?bckey=true&iframed=true',
    responseKeys: ['status', 'flash', 'Client'],
    build(input) {
      return request('post', '/legacy/cake/clients', { data: input })
    },
  },
  legacyPendentsByClient: {
    cake: 'GET /transactions/json/pendents_by_client/all/?layout=ajax',
    responseKeys: ['pendents_by_client', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/transactions/pendents-by-client')
    },
  },
  legacyGlobalSearch: {
    cake: 'GET /transactions/json/globalsearch/{0|1}/sdate:{início}/edate:{fim}/...?pm_detail=true&layout=ajax',
    responseKeys: ['globalsearch', 'loggedin'],
    build(input) {
      return request('get', '/legacy/cake/transactions/globalsearch', {
        params: {
          direction: input.direction,
          start_date: input.startDate,
          end_date: input.endDate,
          pm_detail: true,
        },
      })
    },
  },
  legacyClosedBills: {
    cake: 'GET /bills/json/closed_bills/year/?layout=ajax&nonf',
    responseKeys: ['closed_bills', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/bills/closed', {
        params: { period: 'year', nonf: true },
      })
    },
  },
  legacyPendentServices: {
    cake: 'GET /bills/json/pendent_services/year/?layout=ajax',
    responseKeys: ['pendent_services', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/bills/pendent-services', {
        params: { period: 'year' },
      })
    },
  },
  legacyBillItems: {
    cake: 'GET /bills/json/bill_items/?start_date=&end_date=',
    responseKeys: ['data', 'bills', 'loggedin'],
    build(input) {
      return request('get', '/legacy/cake/bills/items', {
        params: {
          start_date: input.startDate,
          end_date: input.endDate,
        },
      })
    },
  },
  legacyCountries: {
    cake: 'GET /app/json/countries/?layout=ajax',
    responseKeys: ['countries'],
    build() {
      return request('get', '/legacy/cake/app/countries')
    },
  },
  legacyDialCodes: {
    cake: 'GET /app/json/countries/dialcode/?layout=ajax',
    responseKeys: ['countries'],
    build() {
      return request('get', '/legacy/cake/app/countries/dialcode')
    },
  },
  legacyStates: {
    cake: 'GET /app/json/states/{countryId}/?layout=ajax',
    responseKeys: ['states'],
    build(input) {
      return request('get', `/legacy/cake/app/states/${input.countryId}`)
    },
  },
  legacyCities: {
    cake: 'GET /app/json/cities/{stateId}/?layout=ajax',
    responseKeys: ['cities'],
    build(input) {
      return request('get', `/legacy/cake/app/cities/${input.stateId}`)
    },
  },
  legacyListAgents: {
    cake: 'GET /agents/json/list/{uuid}/?layout=ajax',
    responseKeys: ['list', 'loggedin'],
    build(input) {
      const params = {}
      if (input && input.uuid !== undefined && input.uuid !== null && input.uuid !== '') {
        params.uuid = input.uuid
      }
      return request('get', '/legacy/cake/agents', {
        params: Object.keys(params).length ? params : undefined,
      })
    },
  },
  legacyGetAgent: {
    cake: 'GET /agents/json/view/{uuid}',
    responseKeys: ['view', 'loggedin'],
    build(input) {
      return request('get', `/legacy/cake/agents/${input.uuid}`)
    },
  },
  legacyFormations: {
    cake: 'GET /agents/json/formations/?layout=ajax',
    responseKeys: ['formations', 'loggedin'],
    build() {
      return request('get', '/legacy/cake/agents/formations')
    },
  },
  legacySaveAgent: {
    cake: 'POST /agents/save/?vuejs=true',
    responseKeys: ['status', 'flash'],
    build(input) {
      return request('post', '/legacy/cake/agents', { data: input })
    },
  },
  legacyPlaces: {
    cake: 'GET /places/json/list/{cityId},{placeType}/?layout=ajax',
    responseKeys: ['list'],
    build(input) {
      return request('get', '/legacy/cake/places', {
        params: {
          city_id: input.cityId,
          place_type: input.placeType,
        },
      })
    },
  },
  legacySaveHashcode: {
    cake: 'POST /messages/json/create_hashcode/ ou /messages/json/update_hashcode/',
    responseKeys: ['create_hashcode', 'update_hashcode'],
    build(input) {
      return request('post', '/legacy/cake/messages/hashcode', { data: input })
    },
  },
}

export function buildCakeLegacyRequest(name, input) {
  const route = cakeLegacyRoutes[name]
  if (!route) {
    throw new Error(`Rota Cake legada desconhecida: ${name}`)
  }
  return route.build(input)
}

export function createCakeLegacyClient(http) {
  const call = (name, input) => {
    const req = buildCakeLegacyRequest(name, input)
    if (req.method === 'get') {
      return http.get(req.url, { params: req.params })
    }
    return http.post(req.url, req.data)
  }

  return {
    legacyListProducts: () => call('legacyListProducts'),
    legacyProductFieldsMap: () => call('legacyProductFieldsMap'),
    legacyListClients: () => call('legacyListClients'),
    legacyGetClient: (id) => call('legacyGetClient', { id }),
    legacyCountClients: () => call('legacyCountClients'),
    legacyClientFieldsMap: () => call('legacyClientFieldsMap'),
    legacySaveClient: (form) => call('legacySaveClient', form),
    legacyPendentsByClient: () => call('legacyPendentsByClient'),
    legacyGlobalSearch: (direction, startDate, endDate) =>
      call('legacyGlobalSearch', { direction, startDate, endDate }),
    legacyClosedBills: () => call('legacyClosedBills'),
    legacyPendentServices: () => call('legacyPendentServices'),
    legacyBillItems: (startDate, endDate) =>
      call('legacyBillItems', { startDate, endDate }),
    legacyCountries: () => call('legacyCountries'),
    legacyDialCodes: () => call('legacyDialCodes'),
    legacyStates: (countryId) => call('legacyStates', { countryId }),
    legacyCities: (stateId) => call('legacyCities', { stateId }),
    legacyListAgents: (uuid) => call('legacyListAgents', { uuid }),
    legacyGetAgent: (uuid) => call('legacyGetAgent', { uuid }),
    legacyFormations: () => call('legacyFormations'),
    legacySaveAgent: (agent) => call('legacySaveAgent', agent),
    legacyPlaces: (cityId, placeType) =>
      call('legacyPlaces', { cityId, placeType }),
    legacySaveHashcode: (payload) => call('legacySaveHashcode', payload),
  }
}
